import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, vModelText as _vModelText, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "ai-chat" }
const _hoisted_2 = { class: "ai-chat__tabs--wrapper" }
const _hoisted_3 = { class: "ai-chat__tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  id: "ai-chat",
  class: "ai-chat__messages"
}
const _hoisted_7 = { class: "ai-chat__message--avatar" }
const _hoisted_8 = { class: "d-flex align-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "ai-chat__message--avatar-text" }
const _hoisted_11 = { class: "ai-chat__message--avatar-text" }
const _hoisted_12 = { class: "ai-chat__message_text" }
const _hoisted_13 = { class: "mt-auto" }
const _hoisted_14 = { class: "ai-chat__bottom" }
const _hoisted_15 = ["onKeyup", "placeholder", "disabled"]
const _hoisted_16 = ["disabled"]

import { onMounted, ref, watch } from "vue";
import { useLocalization } from "@/plugins/i18n";
import { CabinetApiConnector } from "@/views/cabinet/services/cabinet-api-connector";
import { useSessionStore } from "@/modules/session/store";
import { storeToRefs } from "pinia";

type TabItem = { id: number; name: string };


export default /*#__PURE__*/_defineComponent({
  __name: 'ai-chat',
  setup(__props) {

const { t, dict } = useLocalization();

const sessionStore = useSessionStore();
const { state } = storeToRefs(sessionStore);

const course = ref<any>({});
const dmsData = ref<any>([]);
const threadsData = ref<any>([]);
const courseData = ref([]);
const isLoading = ref(false);

const isType = ref(false);
const question = ref("");
const messageArray = ref<Array<Record<string, any>>>([]);

const tabs = ref<Array<TabItem>>([
  {
    id: 1,
    name: "ask the ai",
  },
  // {
  //   id: 2,
  //   name: "Inquire the Author",
  // },
]);

const tab = ref<number>(1);

const error = ref("");

const getTime = (date = new Date()) => {
  const timeString = date.toLocaleTimeString().slice(0, 5);
  const dateString = date.toLocaleDateString();

  return `${dateString} ${timeString}`;
};

const askQuestion = async () => {
  if (question.value.length) {
    try {
      messageArray.value.push({
        avatar: "ai-you",
        label: t(dict.AI_DEMO.YOU),
        time: getTime(),
        text: question.value,
      });

      const course_lvl_id = course.value.id;
      const user_id = course.value.author_id;
      const message = question.value;
      question.value = "";

      if (tab.value === 1) {
        isType.value = true;

        const result = await CabinetApiConnector.saveFeedbackMessage(
          course_lvl_id,
          message
        );

        messageArray.value.push({
          avatar: "ai-bot",
          label: t(dict.AI_DEMO.AI_CHAT_BOT),
          time: getTime(),
          text: result.data.response,
        });
      } else if (tab.value === 2) {
        await CabinetApiConnector.saveDM(user_id, message);
      }
    } catch (e: any) {
      error.value = e.response.data.error;

      messageArray.value.push({
        avatar: "ai-bot",
        label: t(dict.AI_DEMO.AI_CHAT_BOT),
        time: getTime(),
        text: error.value,
      });
    } finally {
      isType.value = false;
      scrollBottom();
    }
  }
};

const getStart = async () => {
  try {
    tab.value = tabs.value[0].id;
    isLoading.value = true;

    await getMessage();
    const response = await CabinetApiConnector.getCoursesStudent();
    courseData.value = response.data.courses.filter(
      (item: { bot_exist: boolean }) => item.bot_exist
    );
    course.value = courseData.value[0];
  } catch (error) {
    console.log(error, "error");
    // handleError(error);
  } finally {
    isLoading.value = false;
  }
};

watch(course, () => {
  setMessage(course.value.author_id);
});

watch(tab, () => {
  setMessage(course.value.author_id);
});

const setMessage = (author_id: number) => {
  let messagesArray: any = [];
  let messagesLocal: any = [];

  if (tab.value === 1 && threadsData?.value && threadsData.value.length) {
    const thread = threadsData.value.find(
      (item: any) => item.bot_author_id === author_id
    );
    if (thread) {
      messagesArray = thread.messages;
    }
  } else if (tab.value === 2 && dmsData?.value && dmsData.value.length) {
    const dm = dmsData.value.find((item: any) => item.author_id === author_id);
    if (dm) {
      messagesArray = dm.messages;
    }
  }

  if (messagesArray.length) {
    messagesArray.forEach((el: any) => {
      if (tab.value === 1) {
        messagesLocal.push({
          avatar: "ai-you",
          label: t(dict.AI_DEMO.YOU),
          time: getTime(new Date(el.created_at)),
          text: el.message,
        });
        messagesLocal.push({
          avatar: "ai-bot",
          label: t(dict.AI_DEMO.AI_CHAT_BOT),
          time: getTime(new Date(el.created_at)),
          text: el.response,
        });
      } else if (tab.value === 2) {
        messagesLocal.push({
          avatar:
            state.value?.user?.user.id === el.user_id ? "ai-you" : "ai-bot",
          label:
            state.value?.user?.user.id === el.user_id
              ? t(dict.AI_DEMO.YOU)
              : t(dict.AI_DEMO.AI_CHAT_BOT),
          time: getTime(new Date(el.created_at)),
          text: el.message,
        });
      }
    });
  } else {
    messagesLocal.push({
      avatar: "ai-bot",
      label:
        tab.value === 1
          ? t(dict.AI_DEMO.AI_CHAT_BOT)
          : t(dict.AI_DEMO.AUTHOR_CHAT),
      time: getTime(),
      text: t(dict.AI_DEMO.FIRST_MESSAGE),
    });
  }
  messageArray.value = messagesLocal;

  scrollBottom();
};

const scrollBottom = () => {
  setTimeout(() => {
    const chatMessages =
      document.getElementsByClassName("ai-chat__messages")[0];
    chatMessages.scrollTo({
      top: chatMessages.scrollHeight,
      behavior: "smooth",
    });
  }, 10);
};

const getMessage = async () => {
  try {
    const dms = await CabinetApiConnector.getAllDMs();
    dmsData.value = dms.data;
    const threads = await CabinetApiConnector.getFeedbackThreads();
    threadsData.value = threads.data;
  } catch (error) {
    console.log(error, "error");
    // handleError(error);
  }
};

onMounted(async () => {
  await getStart();
});

return (_ctx: any,_cache: any) => {
  const _component_small_arrow_right_icon = _resolveComponent("small-arrow-right-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: _normalizeClass([
            'ai-chat__tabs-item',
            { 'ai-chat__tabs-item--active': item.id === tab.value },
          ]),
            onClick: ($event: any) => (tab.value = item.id)
          }, _toDisplayString(item.name), 11, _hoisted_4))
        }), 128))
      ]),
      (course.value)
        ? _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 0,
            class: "select select--big",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((course).value = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseData.value, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.id,
                value: item
              }, _toDisplayString(item.course_title), 9, _hoisted_5))
            }), 128))
          ], 512)), [
            [_vModelSelect, course.value]
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageArray.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "ai-chat__message",
          key: index
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                src: require(`@/assets/icons/${item.avatar}.svg`),
                alt: "Avatar"
              }, null, 8, _hoisted_9),
              _createElementVNode("div", _hoisted_10, _toDisplayString(item.label), 1)
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.time), 1)
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(item.text), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(['ai-chat__type', { 'ai-chat__type--show': isType.value }])
          }, _toDisplayString(_unref(t)(_unref(dict).AI_DEMO.TYPE)), 3)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          class: "ai-chat__bottom_input",
          onKeyup: _withKeys(askQuestion, ["enter"]),
          type: "text",
          placeholder: _unref(t)(_unref(dict).AI_DEMO.INPUT_PLACEHOLDER),
          disabled: error.value.length,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((question).value = $event))
        }, null, 40, _hoisted_15), [
          [_vModelText, question.value]
        ]),
        _createElementVNode("button", {
          disabled: !question.value.length || error.value.length,
          onClick: askQuestion,
          class: "ai-chat__bottom_button"
        }, [
          _createVNode(_component_small_arrow_right_icon)
        ], 8, _hoisted_16)
      ])
    ])
  ]))
}
}

})